goog.provide("shadow.js.shim.module$react_use$lib$useTimeout$default");
shadow.js.shim.module$react_use$lib$useTimeout$default = shadow.js.shim.module$react_use$lib$useTimeout.default;
